// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Syne:wght@400;500;600;700;800&family=DM+Mono:ital,wght@0,300;0,400;0,500;1,300&family=Instrument+Serif:ital@0;1&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --bg: #f4f6fb;
    --bg-card: #ffffff;
    --bg-card-2: #f0f4ff;
    --border: rgba(79, 124, 255, 0.14);
    --border-hover: rgba(79, 124, 255, 0.35);
    --accent-primary: #3b6cf7;
    --accent-secondary: #7c5be0;
    --accent-green: #0fa66e;
    --accent-amber: #d49000;
    --accent-rose: #e63f5e;
    --accent-cyan: #0898b8;
    --text-primary: #0d1433;
    --text-secondary: #3d4e7a;
    --text-muted: #8a96b8;
    --glow: rgba(79, 124, 255, 0.1);
    --glow-strong: rgba(79, 124, 255, 0.22);
    --radius: 16px;
    --radius-sm: 10px;
}

*,
*::before,
*::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}


/* ── SUBTLE NOISE OVERLAY ── */

.app-wrapper {
    position: relative;
    z-index: 1;
    padding: 16px 24px 20px;
    max-width: 1280px;
    margin: 0 auto;
}

/* ── AMBIENT GLOW ORBS ── */
.orb {
    position: fixed;
    border-radius: 50%;
    filter: blur(130px);
    pointer-events: none;
    z-index: 0;
    animation: orbDrift 20s ease-in-out infinite alternate;
}

.orb-1 {
    width: 600px;
    height: 600px;
    background: radial-gradient(circle, rgba(79, 124, 255, 0.1) 0%, transparent 70%);
    top: -200px;
    left: -200px;
}

.orb-2 {
    width: 500px;
    height: 500px;
    background: radial-gradient(circle, rgba(124, 91, 224, 0.08) 0%, transparent 70%);
    bottom: 0;
    right: -100px;
    animation-delay: -10s;
}

@keyframes orbDrift {
    0% {
        transform: translate(0, 0);
    }

    100% {
        transform: translate(40px, 30px);
    }
}

/* ── HEADER ── */
.pyq-header {
    border-radius: 18px;
    border: 1.5px solid transparent;
    background:
        linear-gradient(#e8f7fb, #e5f8ff) padding-box,
        linear-gradient(135deg, #4f7cff 0%, #a78bfa 50%, #22d3ee 100%) border-box;
    box-shadow:
        0 4px 24px rgba(79, 124, 255, 0.13),
        0 1.5px 6px rgba(79, 124, 255, 0.08);
    padding: 16px;
    margin-bottom: 15px;
    position: relative;
    overflow: hidden;
    opacity: 0;
    transform: translateY(-16px);
    animation: fadeSlideDown 0.6s cubic-bezier(0.16, 1, 0.3, 1) 0.1s forwards;
}

.pyq-header-glow {
    position: absolute;
    top: -60px;
    right: -60px;
    width: 260px;
    height: 260px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(167, 139, 250, 0.12) 0%, transparent 70%);
    pointer-events: none;
}

.pyq-header-badge {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: var(--accent-primary);
    background: linear-gradient(90deg, rgba(79, 124, 255, 0.08), rgba(167, 139, 250, 0.08));
    /* border: 1px solid rgba(79,124,255,0.2); */
    border-radius: 100px;
    padding: 4px 12px 4px 8px;
    margin-bottom: 16px;
}

.pyq-header-badge-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: linear-gradient(135deg, #4f7cff, #a78bfa);
    animation: pulse 2s ease-in-out infinite;
    flex-shrink: 0;
}

.pyq-header h1 {
    font-size: clamp(20px, 3vw, 28px);
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: -0.025em;
    margin: 0 0 4px;
    background: linear-gradient(120deg, #0d1433 30%, #3b6cf7 70%, #7c5be0 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.pyq-header h1 em {
    font-weight: 400;
    font-style: normal;
    background: linear-gradient(120deg, #3d4e7a, #7c5be0);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.pyq-header-divider {
    height: 1px;
    background: linear-gradient(90deg, rgba(79, 124, 255, 0.18), rgba(167, 139, 250, 0.18), transparent);
    margin: 18px 0 16px;
}

.pyq-header-meta {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.meta-chip {
    display: flex;
    align-items: center;
    gap: 7px;
    padding: 6px 14px;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 500;
    color: var(--text-secondary);
    background: rgba(79, 124, 255, 0.06);
    border: 1px solid rgba(79, 124, 255, 0.13);
}

.meta-chip strong {
    color: var(--text-primary);
    font-weight: 700;
}

.meta-sep {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: rgba(79, 124, 255, 0.25);
}

.header-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: rgba(59, 108, 247, 0.08);
    border: 1px solid rgba(59, 108, 247, 0.22);
    border-radius: 100px;
    padding: 6px 16px;
    font-family: 'DM Mono', monospace;
    font-size: 11px;
    letter-spacing: 0.12em;
    color: var(--accent-primary);
    text-transform: uppercase;
    margin-bottom: 20px;
}

.header-badge::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--accent-primary);
    animation: pulse 2s ease-in-out infinite;
}

.header h1 {
    font-family: 'Instrument Serif', serif;
    font-size: clamp(36px, 5vw, 64px);
    font-weight: 400;
    line-height: 1.1;
    letter-spacing: -0.02em;
    background: linear-gradient(135deg, #0d1433 40%, #3b6cf7);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 12px;
}

.header h1 em {
    font-style: italic;
    -webkit-text-fill-color: var(--accent-secondary);
    background: none;
}

.header-meta {
    display: flex;
    align-items: center;
    gap: 24px;
    font-family: 'DM Mono', monospace;
    font-size: 12px;
    color: var(--text-muted);
    letter-spacing: 0.05em;
}

.header-meta span {
    display: flex;
    align-items: center;
    gap: 6px;
}

.header-meta span::before {
    content: '—';
    color: var(--accent-primary);
}

/* ── STATS ROW ── */
.stats-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
    margin-bottom: 16px;
}

.stat-card {
    background: var(--bg-card);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    padding: 24px;
    position: relative;
    overflow: hidden;
    opacity: 0;
    transform: translateY(20px);
    transition: border-color 0.3s, transform 0.3s, box-shadow 0.3s;
    box-shadow: 0 1px 4px rgba(79, 124, 255, 0.06);
}

.stat-card.animated {
    animation: fadeSlideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.stat-card:hover {
    border-color: var(--border-hover);
    transform: translateY(-2px);
    box-shadow: 0 12px 40px rgba(59, 108, 247, 0.12), 0 0 0 1px var(--border-hover);
}

.stat-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, var(--accent-primary), transparent);
    opacity: 0;
    transition: opacity 0.3s;
}

.stat-card:hover::before {
    opacity: 1;
}

.stat-label {
    font-family: 'DM Mono', monospace;
    font-size: 10px;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: var(--text-muted);
    margin-bottom: 12px;
}

.stat-value {
    font-size: 42px;
    font-weight: 800;
    line-height: 1;
    letter-spacing: -0.02em;
    background: linear-gradient(135deg, var(--text-primary), var(--accent-primary));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.stat-sub {
    font-family: 'DM Mono', monospace;
    font-size: 11px;
    color: var(--text-muted);
    margin-top: 6px;
}

/* ── SECTION TITLES ── */
.section-title {
    font-family: 'DM Mono', monospace;
    font-size: 10px;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: var(--accent-primary);
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
    opacity: 0;
    animation: fadeIn 0.5s ease forwards;
}

.section-title::after {
    content: '';
    flex: 1 1;
    height: 1px;
    background: linear-gradient(90deg, rgba(59, 108, 247, 0.2), transparent);
}

/* ── DISTRIBUTION GRID ── */
.dist-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 20px;
    margin-bottom: 16px;
}

.dist-card {
    background: var(--bg-card);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    padding: 28px;
    opacity: 0;
    transition: border-color 0.3s, box-shadow 0.3s;
    box-shadow: 0 1px 4px rgba(79, 124, 255, 0.05);
}

.dist-card.animated {
    animation: fadeSlideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.dist-card:hover {
    border-color: var(--border-hover);
    box-shadow: 0 12px 40px rgba(59, 108, 247, 0.1);
}

.dist-card-title {
    font-size: 13px;
    font-weight: 600;
    color: var(--text-secondary);
    letter-spacing: 0.02em;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.dist-card-title-icon {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
}

/* ── BAR CHART ── */
.bar-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 14px;
}

.bar-label {
    font-family: 'DM Mono', monospace;
    font-size: 11px;
    color: var(--text-secondary);
    width: 90px;
    flex-shrink: 0;
    text-align: right;
}

.bar-track {
    flex: 1 1;
    height: 6px;
    background: rgba(59, 108, 247, 0.07);
    border-radius: 100px;
    overflow: hidden;
}

.bar-fill {
    height: 100%;
    border-radius: 100px;
    width: 0%;
    transition: width 1.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.bar-pct {
    font-family: 'DM Mono', monospace;
    font-size: 11px;
    color: var(--text-muted);
    width: 36px;
    text-align: right;
}

/* ── DONUT CHART ── */
.donut-container {
    display: flex;
    align-items: center;
    gap: 28px;
}

.donut-svg {
    flex-shrink: 0;
}

.donut-legend {
    flex: 1 1;
}

.legend-item {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
}

.legend-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
}

.legend-name {
    font-size: 12px;
    color: var(--text-secondary);
    flex: 1 1;
}

.legend-val {
    font-family: 'DM Mono', monospace;
    font-size: 11px;
    color: var(--text-muted);
}

/* ── UNITS TABLE ── */
.units-section {
    margin-bottom: 16px;
}

.units-grid {
    display: grid;
    gap: 10px;
}

.unit-row {
    background: var(--bg-card);
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    padding: 16px 20px;
    display: grid;
    grid-template-columns: 1fr auto auto;
    align-items: center;
    gap: 20px;
    cursor: pointer;
    transition: border-color 0.25s, transform 0.25s, box-shadow 0.25s;
    opacity: 0;
    box-shadow: 0 1px 3px rgba(79, 124, 255, 0.04);
}

.unit-row.animated {
    animation: fadeSlideRight 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.unit-row:hover {
    border-color: var(--border-hover);
    transform: translateX(4px);
    box-shadow: 0 4px 20px rgba(59, 108, 247, 0.1), -3px 0 0 var(--accent-primary);
}

.unit-row.expanded {
    border-color: rgba(59, 108, 247, 0.3);
    background: var(--bg-card-2);
}

.unit-name {
    font-size: 13px;
    font-weight: 600;
    color: var(--text-primary);
    letter-spacing: 0.01em;
    line-height: 1.4;
}

.unit-badges {
    display: flex;
    gap: 8px;
    align-items: center;
}

.badge {
    font-family: 'DM Mono', monospace;
    font-size: 9px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    padding: 3px 9px;
    border-radius: 100px;
    font-weight: 500;
}

.badge-hybrid {
    background: rgba(124, 91, 224, 0.1);
    color: var(--accent-secondary) !important;
    border: 1px solid rgba(124, 91, 224, 0.22);
}

.badge-conceptual {
    background: rgba(8, 152, 184, 0.08);
    color: var(--accent-cyan) !important;
    border: 1px solid rgba(8, 152, 184, 0.2);
}

.badge-static {
    background: rgba(212, 144, 0, 0.1);
    color: var(--accent-amber) !important;
    border: 1px solid rgba(212, 144, 0, 0.2);
}

.badge-application {
    background: rgba(15, 166, 110, 0.1);
    color: var(--accent-green) !important;
    border: 1px solid rgba(15, 166, 110, 0.2);
}

.badge-high {
    background: rgba(15, 166, 110, 0.08);
    color: var(--accent-green) !important;
    border: 1px solid rgba(15, 166, 110, 0.18);
}

.badge-medium {
    background: rgba(212, 144, 0, 0.08);
    color: var(--accent-amber) !important;
    border: 1px solid rgba(212, 144, 0, 0.18);
}

.badge-low {
    background: rgba(230, 63, 94, 0.08);
    color: var(--accent-rose) !important;
    border: 1px solid rgba(230, 63, 94, 0.18);
}

.unit-weight {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 6px;
    min-width: 80px;
}

.weight-num {
    font-family: 'DM Mono', monospace;
    font-size: 22px;
    font-weight: 500;
    color: var(--accent-primary) !important;
    line-height: 1;
}

.weight-bar-mini {
    width: 80px;
    height: 3px;
    background: rgba(59, 108, 247, 0.1);
    border-radius: 100px;
    overflow: hidden;
}

.weight-bar-fill {
    height: 100%;
    background: linear-gradient(90deg, var(--accent-primary), var(--accent-secondary));
    border-radius: 100px;
    transition: width 1s cubic-bezier(0.16, 1, 0.3, 1);
}

/* ── EXPANDED TOPICS ── */
.topics-panel {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.5s cubic-bezier(0.16, 1, 0.3, 1);
    background: #f7f9ff;
    border-top: 1px solid var(--border);
    border-radius: 0 0 var(--radius-sm) var(--radius-sm);
}

.topics-panel.open {
    max-height: 800px;
}

.topics-inner {
    padding: 16px 20px;
    display: grid;
    gap: 8px;
}

.topic-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid rgba(59, 108, 247, 0.08);
    transition: background 0.2s, border-color 0.2s;
}

.topic-item:hover {
    background: rgba(59, 108, 247, 0.04);
    border-color: rgba(59, 108, 247, 0.18);
}

.topic-dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: var(--accent-primary);
    flex-shrink: 0;
}

.topic-name {
    font-size: 12px;
    color: var(--text-secondary);
    flex: 1 1;
    line-height: 1.4;
}

.topic-badges {
    display: flex;
    align-items: center;
    gap: 6px;
}

/* ── PATTERN INSIGHTS ── */
.insights-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 16px;
    margin-bottom: 16px;
}

.insight-card {
    background: var(--bg-card);
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    padding: 20px;
    position: relative;
    overflow: hidden;
    opacity: 0;
    transition: border-color 0.3s, transform 0.3s;
    box-shadow: 0 1px 3px rgba(79, 124, 255, 0.05);
}

.insight-card.animated {
    animation: fadeSlideUp 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.insight-card:hover {
    border-color: var(--border-hover);
    transform: translateY(-2px);
    box-shadow: 0 8px 30px rgba(59, 108, 247, 0.09);
}

.insight-num {
    font-family: 'DM Mono', monospace;
    font-size: 10px;
    color: var(--accent-primary);
    letter-spacing: 0.1em;
    margin-bottom: 10px;
    display: block;
    opacity: 0.7;
}

.insight-text {
    font-size: 12.5px;
    color: var(--text-secondary);
    line-height: 1.65;
}

.insight-card::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50px;
    background: linear-gradient(transparent, rgba(59, 108, 247, 0.03));
    pointer-events: none;
}

/* ── VISUAL TYPES ── */
.visual-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.visual-tag {
    background: #f7f9ff;
    border: 1px solid var(--border);
    border-radius: 10px;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    gap: 10px;
    transition: border-color 0.2s, background 0.2s;
}

.visual-tag:hover {
    border-color: var(--border-hover);
    background: rgba(59, 108, 247, 0.05);
}

.visual-tag-icon {
    font-size: 18px;
}

.visual-tag-info {
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.visual-tag-name {
    font-size: 12px;
    font-weight: 600;
    color: var(--text-primary);
}

.visual-tag-role {
    font-size: 10px;
    color: var(--text-muted);
    font-family: 'DM Mono', monospace;
}

/* ── CHEVRON ── */
.chevron {
    color: var(--text-muted);
    transition: transform 0.3s;
    font-size: 14px;
    -webkit-user-select: none;
            user-select: none;
}

.unit-row.expanded .chevron {
    transform: rotate(180deg);
}

/* ── ANIMATIONS ── */
@keyframes fadeSlideDown {
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeSlideUp {
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeSlideRight {
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

@keyframes fadeIn {
    to {
        opacity: 1;
    }
}

@keyframes pulse {

    0%,
    100% {
        opacity: 1;
        transform: scale(1);
    }

    50% {
        opacity: 0.5;
        transform: scale(0.8);
    }
}

/* ── SHIMMER ── */
.shimmer {
    background: linear-gradient(90deg, #f0f4ff 25%, #e8eeff 50%, #f0f4ff 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
    0% {
        background-position: 200% 0;
    }

    100% {
        background-position: -200% 0;
    }
}

/* ── LOADING STATE ── */
.loading-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 60vh;
    gap: 20px;
}

.loading-ring {
    width: 48px;
    height: 48px;
    border: 2px solid rgba(59, 108, 247, 0.15);
    border-top-color: var(--accent-primary);
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.loading-text {
    font-family: 'DM Mono', monospace;
    font-size: 12px;
    color: var(--text-muted);
    letter-spacing: 0.1em;
}

/* ── SCROLLBAR ── */
::-webkit-scrollbar {
    width: 6px;
}

::-webkit-scrollbar-track {
    background: #eef1fa;
}

::-webkit-scrollbar-thumb {
    background: rgba(59, 108, 247, 0.2);
    border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
    background: rgba(59, 108, 247, 0.4);
}

/* ── RESPONSIVE ── */
@media (max-width: 640px) {
    .app-wrapper {
        padding: 24px 16px 60px;
    }

    .dist-grid {
        grid-template-columns: 1fr;
    }

    .unit-row {
        grid-template-columns: 1fr;
        gap: 10px;
    }

    .unit-weight {
        flex-direction: row;
        align-items: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/Screen/AIPanel/knowledgeBaseUpload/pyqAnalyticsDashboard.css"],"names":[],"mappings":"AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,kCAAkC;IAClC,wCAAwC;IACxC,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,qBAAqB;IACrB,+BAA+B;IAC/B,uCAAuC;IACvC,cAAc;IACd,iBAAiB;AACrB;;AAEA;;;IAGI,sBAAsB;IACtB,SAAS;IACT,UAAU;AACd;;;AAGA,+BAA+B;;AAE/B;IACI,kBAAkB;IAClB,UAAU;IACV,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;AAClB;;AAEA,4BAA4B;AAC5B;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,UAAU;IACV,sDAAsD;AAC1D;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gFAAgF;IAChF,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iFAAiF;IACjF,SAAS;IACT,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;IACpC;AACJ;;AAEA,iBAAiB;AACjB;IACI,mBAAmB;IACnB,+BAA+B;IAC/B;;iFAE6E;IAC7E;;4CAEwC;IACxC,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,4BAA4B;IAC5B,yEAAyE;AAC7E;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kFAAkF;IAClF,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,4BAA4B;IAC5B,uFAAuF;IACvF,4CAA4C;IAC5C,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,qDAAqD;IACrD,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;IACxB,eAAe;IACf,2EAA2E;IAC3E,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,qDAAqD;IACrD,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,oGAAoG;IACpG,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,oCAAoC;IACpC,0CAA0C;AAC9C;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,oCAAoC;IACpC,0CAA0C;IAC1C,oBAAoB;IACpB,iBAAiB;IACjB,iCAAiC;IACjC,eAAe;IACf,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,iCAAiC;IACjC,wCAAwC;AAC5C;;AAEA;IACI,sCAAsC;IACtC,iCAAiC;IACjC,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,yDAAyD;IACzD,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gDAAgD;IAChD,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iCAAiC;IACjC,eAAe;IACf,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,4BAA4B;AAChC;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,+BAA+B;IAC/B,4BAA4B;IAC5B,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,2BAA2B;IAC3B,8DAA8D;IAC9D,8CAA8C;AAClD;;AAEA;IACI,kEAAkE;AACtE;;AAEA;IACI,iCAAiC;IACjC,2BAA2B;IAC3B,+EAA+E;AACnF;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,mFAAmF;IACnF,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,+EAA+E;IAC/E,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,wBAAwB;IACxB,eAAe;AACnB;;AAEA,yBAAyB;AACzB;IACI,iCAAiC;IACjC,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,UAAU;IACV,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,SAAO;IACP,WAAW;IACX,wEAAwE;AAC5E;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,+BAA+B;IAC/B,4BAA4B;IAC5B,aAAa;IACb,UAAU;IACV,8CAA8C;IAC9C,8CAA8C;AAClD;;AAEA;IACI,kEAAkE;AACtE;;AAEA;IACI,iCAAiC;IACjC,+CAA+C;AACnD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,4BAA4B;IAC5B,WAAW;IACX,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,WAAW;IACX,oCAAoC;IACpC,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,SAAS;IACT,oDAAoD;AACxD;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,wBAAwB;IACxB,WAAW;IACX,iBAAiB;AACrB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,SAAO;AACX;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,wBAAwB;AAC5B;;AAEA,sBAAsB;AACtB;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,+BAA+B;IAC/B,+BAA+B;IAC/B,kBAAkB;IAClB,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,iEAAiE;IACjE,UAAU;IACV,8CAA8C;AAClD;;AAEA;IACI,qEAAqE;AACzE;;AAEA;IACI,iCAAiC;IACjC,0BAA0B;IAC1B,8EAA8E;AAClF;;AAEA;IACI,qCAAqC;IACrC,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,yCAAyC;IACzC,0CAA0C;AAC9C;;AAEA;IACI,mCAAmC;IACnC,oCAAoC;IACpC,wCAAwC;AAC5C;;AAEA;IACI,kCAAkC;IAClC,qCAAqC;IACrC,wCAAwC;AAC5C;;AAEA;IACI,mCAAmC;IACnC,qCAAqC;IACrC,yCAAyC;AAC7C;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;IACrC,0CAA0C;AAC9C;;AAEA;IACI,mCAAmC;IACnC,qCAAqC;IACrC,yCAAyC;AAC7C;;AAEA;IACI,mCAAmC;IACnC,oCAAoC;IACpC,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,uCAAuC;IACvC,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mCAAmC;IACnC,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kFAAkF;IAClF,oBAAoB;IACpB,kDAAkD;AACtD;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,gBAAgB;IAChB,yDAAyD;IACzD,mBAAmB;IACnB,mCAAmC;IACnC,oDAAoD;AACxD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,0CAA0C;IAC1C,8CAA8C;AAClD;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,+BAA+B;IAC/B,+BAA+B;IAC/B,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,6CAA6C;IAC7C,8CAA8C;AAClD;;AAEA;IACI,kEAAkE;AACtE;;AAEA;IACI,iCAAiC;IACjC,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,4BAA4B;IAC5B,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,kEAAkE;IAClE,oBAAoB;AACxB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,8CAA8C;AAClD;;AAEA;IACI,iCAAiC;IACjC,oCAAoC;AACxC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,iCAAiC;AACrC;;AAEA,kBAAkB;AAClB;IACI,wBAAwB;IACxB,0BAA0B;IAC1B,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,qBAAqB;AACrB;IACI;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;;IAEI;;QAEI,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,qBAAqB;IACzB;AACJ;;AAEA,kBAAkB;AAClB;IACI,yEAAyE;IACzE,0BAA0B;IAC1B,gCAAgC;AACpC;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,uCAAuC;IACvC,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA,oBAAoB;AACpB;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;AACvC;;AAEA,qBAAqB;AACrB;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;IACvB;AACJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;500;600;700;800&family=DM+Mono:ital,wght@0,300;0,400;0,500;1,300&family=Instrument+Serif:ital@0;1&display=swap');\n\n:root {\n    --bg: #f4f6fb;\n    --bg-card: #ffffff;\n    --bg-card-2: #f0f4ff;\n    --border: rgba(79, 124, 255, 0.14);\n    --border-hover: rgba(79, 124, 255, 0.35);\n    --accent-primary: #3b6cf7;\n    --accent-secondary: #7c5be0;\n    --accent-green: #0fa66e;\n    --accent-amber: #d49000;\n    --accent-rose: #e63f5e;\n    --accent-cyan: #0898b8;\n    --text-primary: #0d1433;\n    --text-secondary: #3d4e7a;\n    --text-muted: #8a96b8;\n    --glow: rgba(79, 124, 255, 0.1);\n    --glow-strong: rgba(79, 124, 255, 0.22);\n    --radius: 16px;\n    --radius-sm: 10px;\n}\n\n*,\n*::before,\n*::after {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n}\n\n\n/* ── SUBTLE NOISE OVERLAY ── */\n\n.app-wrapper {\n    position: relative;\n    z-index: 1;\n    padding: 16px 24px 20px;\n    max-width: 1280px;\n    margin: 0 auto;\n}\n\n/* ── AMBIENT GLOW ORBS ── */\n.orb {\n    position: fixed;\n    border-radius: 50%;\n    filter: blur(130px);\n    pointer-events: none;\n    z-index: 0;\n    animation: orbDrift 20s ease-in-out infinite alternate;\n}\n\n.orb-1 {\n    width: 600px;\n    height: 600px;\n    background: radial-gradient(circle, rgba(79, 124, 255, 0.1) 0%, transparent 70%);\n    top: -200px;\n    left: -200px;\n}\n\n.orb-2 {\n    width: 500px;\n    height: 500px;\n    background: radial-gradient(circle, rgba(124, 91, 224, 0.08) 0%, transparent 70%);\n    bottom: 0;\n    right: -100px;\n    animation-delay: -10s;\n}\n\n@keyframes orbDrift {\n    0% {\n        transform: translate(0, 0);\n    }\n\n    100% {\n        transform: translate(40px, 30px);\n    }\n}\n\n/* ── HEADER ── */\n.pyq-header {\n    border-radius: 18px;\n    border: 1.5px solid transparent;\n    background:\n        linear-gradient(#e8f7fb, #e5f8ff) padding-box,\n        linear-gradient(135deg, #4f7cff 0%, #a78bfa 50%, #22d3ee 100%) border-box;\n    box-shadow:\n        0 4px 24px rgba(79, 124, 255, 0.13),\n        0 1.5px 6px rgba(79, 124, 255, 0.08);\n    padding: 16px;\n    margin-bottom: 15px;\n    position: relative;\n    overflow: hidden;\n    opacity: 0;\n    transform: translateY(-16px);\n    animation: fadeSlideDown 0.6s cubic-bezier(0.16, 1, 0.3, 1) 0.1s forwards;\n}\n\n.pyq-header-glow {\n    position: absolute;\n    top: -60px;\n    right: -60px;\n    width: 260px;\n    height: 260px;\n    border-radius: 50%;\n    background: radial-gradient(circle, rgba(167, 139, 250, 0.12) 0%, transparent 70%);\n    pointer-events: none;\n}\n\n.pyq-header-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 7px;\n    font-size: 11px;\n    font-weight: 500;\n    letter-spacing: 0.07em;\n    text-transform: uppercase;\n    color: var(--accent-primary);\n    background: linear-gradient(90deg, rgba(79, 124, 255, 0.08), rgba(167, 139, 250, 0.08));\n    /* border: 1px solid rgba(79,124,255,0.2); */\n    border-radius: 100px;\n    padding: 4px 12px 4px 8px;\n    margin-bottom: 16px;\n}\n\n.pyq-header-badge-dot {\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, #4f7cff, #a78bfa);\n    animation: pulse 2s ease-in-out infinite;\n    flex-shrink: 0;\n}\n\n.pyq-header h1 {\n    font-size: clamp(20px, 3vw, 28px);\n    font-weight: 700;\n    line-height: 1.2;\n    letter-spacing: -0.025em;\n    margin: 0 0 4px;\n    background: linear-gradient(120deg, #0d1433 30%, #3b6cf7 70%, #7c5be0 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n.pyq-header h1 em {\n    font-weight: 400;\n    font-style: normal;\n    background: linear-gradient(120deg, #3d4e7a, #7c5be0);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n.pyq-header-divider {\n    height: 1px;\n    background: linear-gradient(90deg, rgba(79, 124, 255, 0.18), rgba(167, 139, 250, 0.18), transparent);\n    margin: 18px 0 16px;\n}\n\n.pyq-header-meta {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.meta-chip {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    padding: 6px 14px;\n    border-radius: 10px;\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--text-secondary);\n    background: rgba(79, 124, 255, 0.06);\n    border: 1px solid rgba(79, 124, 255, 0.13);\n}\n\n.meta-chip strong {\n    color: var(--text-primary);\n    font-weight: 700;\n}\n\n.meta-sep {\n    width: 4px;\n    height: 4px;\n    border-radius: 50%;\n    background: rgba(79, 124, 255, 0.25);\n}\n\n.header-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    background: rgba(59, 108, 247, 0.08);\n    border: 1px solid rgba(59, 108, 247, 0.22);\n    border-radius: 100px;\n    padding: 6px 16px;\n    font-family: 'DM Mono', monospace;\n    font-size: 11px;\n    letter-spacing: 0.12em;\n    color: var(--accent-primary);\n    text-transform: uppercase;\n    margin-bottom: 20px;\n}\n\n.header-badge::before {\n    content: '';\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: var(--accent-primary);\n    animation: pulse 2s ease-in-out infinite;\n}\n\n.header h1 {\n    font-family: 'Instrument Serif', serif;\n    font-size: clamp(36px, 5vw, 64px);\n    font-weight: 400;\n    line-height: 1.1;\n    letter-spacing: -0.02em;\n    background: linear-gradient(135deg, #0d1433 40%, #3b6cf7);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    margin-bottom: 12px;\n}\n\n.header h1 em {\n    font-style: italic;\n    -webkit-text-fill-color: var(--accent-secondary);\n    background: none;\n}\n\n.header-meta {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    font-family: 'DM Mono', monospace;\n    font-size: 12px;\n    color: var(--text-muted);\n    letter-spacing: 0.05em;\n}\n\n.header-meta span {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.header-meta span::before {\n    content: '—';\n    color: var(--accent-primary);\n}\n\n/* ── STATS ROW ── */\n.stats-row {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 16px;\n    margin-bottom: 16px;\n}\n\n.stat-card {\n    background: var(--bg-card);\n    border: 1px solid var(--border);\n    border-radius: var(--radius);\n    padding: 24px;\n    position: relative;\n    overflow: hidden;\n    opacity: 0;\n    transform: translateY(20px);\n    transition: border-color 0.3s, transform 0.3s, box-shadow 0.3s;\n    box-shadow: 0 1px 4px rgba(79, 124, 255, 0.06);\n}\n\n.stat-card.animated {\n    animation: fadeSlideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n.stat-card:hover {\n    border-color: var(--border-hover);\n    transform: translateY(-2px);\n    box-shadow: 0 12px 40px rgba(59, 108, 247, 0.12), 0 0 0 1px var(--border-hover);\n}\n\n.stat-card::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 2px;\n    background: linear-gradient(90deg, transparent, var(--accent-primary), transparent);\n    opacity: 0;\n    transition: opacity 0.3s;\n}\n\n.stat-card:hover::before {\n    opacity: 1;\n}\n\n.stat-label {\n    font-family: 'DM Mono', monospace;\n    font-size: 10px;\n    letter-spacing: 0.14em;\n    text-transform: uppercase;\n    color: var(--text-muted);\n    margin-bottom: 12px;\n}\n\n.stat-value {\n    font-size: 42px;\n    font-weight: 800;\n    line-height: 1;\n    letter-spacing: -0.02em;\n    background: linear-gradient(135deg, var(--text-primary), var(--accent-primary));\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n.stat-sub {\n    font-family: 'DM Mono', monospace;\n    font-size: 11px;\n    color: var(--text-muted);\n    margin-top: 6px;\n}\n\n/* ── SECTION TITLES ── */\n.section-title {\n    font-family: 'DM Mono', monospace;\n    font-size: 10px;\n    letter-spacing: 0.18em;\n    text-transform: uppercase;\n    color: var(--accent-primary);\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 20px;\n    opacity: 0;\n    animation: fadeIn 0.5s ease forwards;\n}\n\n.section-title::after {\n    content: '';\n    flex: 1;\n    height: 1px;\n    background: linear-gradient(90deg, rgba(59, 108, 247, 0.2), transparent);\n}\n\n/* ── DISTRIBUTION GRID ── */\n.dist-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n    gap: 20px;\n    margin-bottom: 16px;\n}\n\n.dist-card {\n    background: var(--bg-card);\n    border: 1px solid var(--border);\n    border-radius: var(--radius);\n    padding: 28px;\n    opacity: 0;\n    transition: border-color 0.3s, box-shadow 0.3s;\n    box-shadow: 0 1px 4px rgba(79, 124, 255, 0.05);\n}\n\n.dist-card.animated {\n    animation: fadeSlideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n.dist-card:hover {\n    border-color: var(--border-hover);\n    box-shadow: 0 12px 40px rgba(59, 108, 247, 0.1);\n}\n\n.dist-card-title {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--text-secondary);\n    letter-spacing: 0.02em;\n    margin-bottom: 24px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.dist-card-title-icon {\n    width: 28px;\n    height: 28px;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n}\n\n/* ── BAR CHART ── */\n.bar-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 14px;\n}\n\n.bar-label {\n    font-family: 'DM Mono', monospace;\n    font-size: 11px;\n    color: var(--text-secondary);\n    width: 90px;\n    flex-shrink: 0;\n    text-align: right;\n}\n\n.bar-track {\n    flex: 1;\n    height: 6px;\n    background: rgba(59, 108, 247, 0.07);\n    border-radius: 100px;\n    overflow: hidden;\n}\n\n.bar-fill {\n    height: 100%;\n    border-radius: 100px;\n    width: 0%;\n    transition: width 1.2s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.bar-pct {\n    font-family: 'DM Mono', monospace;\n    font-size: 11px;\n    color: var(--text-muted);\n    width: 36px;\n    text-align: right;\n}\n\n/* ── DONUT CHART ── */\n.donut-container {\n    display: flex;\n    align-items: center;\n    gap: 28px;\n}\n\n.donut-svg {\n    flex-shrink: 0;\n}\n\n.donut-legend {\n    flex: 1;\n}\n\n.legend-item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 10px;\n}\n\n.legend-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n\n.legend-name {\n    font-size: 12px;\n    color: var(--text-secondary);\n    flex: 1;\n}\n\n.legend-val {\n    font-family: 'DM Mono', monospace;\n    font-size: 11px;\n    color: var(--text-muted);\n}\n\n/* ── UNITS TABLE ── */\n.units-section {\n    margin-bottom: 16px;\n}\n\n.units-grid {\n    display: grid;\n    gap: 10px;\n}\n\n.unit-row {\n    background: var(--bg-card);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-sm);\n    padding: 16px 20px;\n    display: grid;\n    grid-template-columns: 1fr auto auto;\n    align-items: center;\n    gap: 20px;\n    cursor: pointer;\n    transition: border-color 0.25s, transform 0.25s, box-shadow 0.25s;\n    opacity: 0;\n    box-shadow: 0 1px 3px rgba(79, 124, 255, 0.04);\n}\n\n.unit-row.animated {\n    animation: fadeSlideRight 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n.unit-row:hover {\n    border-color: var(--border-hover);\n    transform: translateX(4px);\n    box-shadow: 0 4px 20px rgba(59, 108, 247, 0.1), -3px 0 0 var(--accent-primary);\n}\n\n.unit-row.expanded {\n    border-color: rgba(59, 108, 247, 0.3);\n    background: var(--bg-card-2);\n}\n\n.unit-name {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--text-primary);\n    letter-spacing: 0.01em;\n    line-height: 1.4;\n}\n\n.unit-badges {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.badge {\n    font-family: 'DM Mono', monospace;\n    font-size: 9px;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    padding: 3px 9px;\n    border-radius: 100px;\n    font-weight: 500;\n}\n\n.badge-hybrid {\n    background: rgba(124, 91, 224, 0.1);\n    color: var(--accent-secondary) !important;\n    border: 1px solid rgba(124, 91, 224, 0.22);\n}\n\n.badge-conceptual {\n    background: rgba(8, 152, 184, 0.08);\n    color: var(--accent-cyan) !important;\n    border: 1px solid rgba(8, 152, 184, 0.2);\n}\n\n.badge-static {\n    background: rgba(212, 144, 0, 0.1);\n    color: var(--accent-amber) !important;\n    border: 1px solid rgba(212, 144, 0, 0.2);\n}\n\n.badge-application {\n    background: rgba(15, 166, 110, 0.1);\n    color: var(--accent-green) !important;\n    border: 1px solid rgba(15, 166, 110, 0.2);\n}\n\n.badge-high {\n    background: rgba(15, 166, 110, 0.08);\n    color: var(--accent-green) !important;\n    border: 1px solid rgba(15, 166, 110, 0.18);\n}\n\n.badge-medium {\n    background: rgba(212, 144, 0, 0.08);\n    color: var(--accent-amber) !important;\n    border: 1px solid rgba(212, 144, 0, 0.18);\n}\n\n.badge-low {\n    background: rgba(230, 63, 94, 0.08);\n    color: var(--accent-rose) !important;\n    border: 1px solid rgba(230, 63, 94, 0.18);\n}\n\n.unit-weight {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 6px;\n    min-width: 80px;\n}\n\n.weight-num {\n    font-family: 'DM Mono', monospace;\n    font-size: 22px;\n    font-weight: 500;\n    color: var(--accent-primary) !important;\n    line-height: 1;\n}\n\n.weight-bar-mini {\n    width: 80px;\n    height: 3px;\n    background: rgba(59, 108, 247, 0.1);\n    border-radius: 100px;\n    overflow: hidden;\n}\n\n.weight-bar-fill {\n    height: 100%;\n    background: linear-gradient(90deg, var(--accent-primary), var(--accent-secondary));\n    border-radius: 100px;\n    transition: width 1s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n/* ── EXPANDED TOPICS ── */\n.topics-panel {\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.5s cubic-bezier(0.16, 1, 0.3, 1);\n    background: #f7f9ff;\n    border-top: 1px solid var(--border);\n    border-radius: 0 0 var(--radius-sm) var(--radius-sm);\n}\n\n.topics-panel.open {\n    max-height: 800px;\n}\n\n.topics-inner {\n    padding: 16px 20px;\n    display: grid;\n    gap: 8px;\n}\n\n.topic-item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 10px 14px;\n    background: #ffffff;\n    border-radius: 8px;\n    border: 1px solid rgba(59, 108, 247, 0.08);\n    transition: background 0.2s, border-color 0.2s;\n}\n\n.topic-item:hover {\n    background: rgba(59, 108, 247, 0.04);\n    border-color: rgba(59, 108, 247, 0.18);\n}\n\n.topic-dot {\n    width: 5px;\n    height: 5px;\n    border-radius: 50%;\n    background: var(--accent-primary);\n    flex-shrink: 0;\n}\n\n.topic-name {\n    font-size: 12px;\n    color: var(--text-secondary);\n    flex: 1;\n    line-height: 1.4;\n}\n\n.topic-badges {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n/* ── PATTERN INSIGHTS ── */\n.insights-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n    gap: 16px;\n    margin-bottom: 16px;\n}\n\n.insight-card {\n    background: var(--bg-card);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-sm);\n    padding: 20px;\n    position: relative;\n    overflow: hidden;\n    opacity: 0;\n    transition: border-color 0.3s, transform 0.3s;\n    box-shadow: 0 1px 3px rgba(79, 124, 255, 0.05);\n}\n\n.insight-card.animated {\n    animation: fadeSlideUp 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n.insight-card:hover {\n    border-color: var(--border-hover);\n    transform: translateY(-2px);\n    box-shadow: 0 8px 30px rgba(59, 108, 247, 0.09);\n}\n\n.insight-num {\n    font-family: 'DM Mono', monospace;\n    font-size: 10px;\n    color: var(--accent-primary);\n    letter-spacing: 0.1em;\n    margin-bottom: 10px;\n    display: block;\n    opacity: 0.7;\n}\n\n.insight-text {\n    font-size: 12.5px;\n    color: var(--text-secondary);\n    line-height: 1.65;\n}\n\n.insight-card::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 50px;\n    background: linear-gradient(transparent, rgba(59, 108, 247, 0.03));\n    pointer-events: none;\n}\n\n/* ── VISUAL TYPES ── */\n.visual-tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n\n.visual-tag {\n    background: #f7f9ff;\n    border: 1px solid var(--border);\n    border-radius: 10px;\n    padding: 12px 16px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    transition: border-color 0.2s, background 0.2s;\n}\n\n.visual-tag:hover {\n    border-color: var(--border-hover);\n    background: rgba(59, 108, 247, 0.05);\n}\n\n.visual-tag-icon {\n    font-size: 18px;\n}\n\n.visual-tag-info {\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n}\n\n.visual-tag-name {\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.visual-tag-role {\n    font-size: 10px;\n    color: var(--text-muted);\n    font-family: 'DM Mono', monospace;\n}\n\n/* ── CHEVRON ── */\n.chevron {\n    color: var(--text-muted);\n    transition: transform 0.3s;\n    font-size: 14px;\n    user-select: none;\n}\n\n.unit-row.expanded .chevron {\n    transform: rotate(180deg);\n}\n\n/* ── ANIMATIONS ── */\n@keyframes fadeSlideDown {\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes fadeSlideUp {\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes fadeSlideRight {\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n@keyframes fadeIn {\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes pulse {\n\n    0%,\n    100% {\n        opacity: 1;\n        transform: scale(1);\n    }\n\n    50% {\n        opacity: 0.5;\n        transform: scale(0.8);\n    }\n}\n\n/* ── SHIMMER ── */\n.shimmer {\n    background: linear-gradient(90deg, #f0f4ff 25%, #e8eeff 50%, #f0f4ff 75%);\n    background-size: 200% 100%;\n    animation: shimmer 1.5s infinite;\n}\n\n@keyframes shimmer {\n    0% {\n        background-position: 200% 0;\n    }\n\n    100% {\n        background-position: -200% 0;\n    }\n}\n\n/* ── LOADING STATE ── */\n.loading-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 60vh;\n    gap: 20px;\n}\n\n.loading-ring {\n    width: 48px;\n    height: 48px;\n    border: 2px solid rgba(59, 108, 247, 0.15);\n    border-top-color: var(--accent-primary);\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.loading-text {\n    font-family: 'DM Mono', monospace;\n    font-size: 12px;\n    color: var(--text-muted);\n    letter-spacing: 0.1em;\n}\n\n/* ── SCROLLBAR ── */\n::-webkit-scrollbar {\n    width: 6px;\n}\n\n::-webkit-scrollbar-track {\n    background: #eef1fa;\n}\n\n::-webkit-scrollbar-thumb {\n    background: rgba(59, 108, 247, 0.2);\n    border-radius: 3px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background: rgba(59, 108, 247, 0.4);\n}\n\n/* ── RESPONSIVE ── */\n@media (max-width: 640px) {\n    .app-wrapper {\n        padding: 24px 16px 60px;\n    }\n\n    .dist-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .unit-row {\n        grid-template-columns: 1fr;\n        gap: 10px;\n    }\n\n    .unit-weight {\n        flex-direction: row;\n        align-items: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
